import { categoryFrag } from './service-settings-documents.query';
import { Component, computed, inject, viewChild } from '@angular/core';
import { ServiceSettingsDocumentsStore } from './service-settings-documents.store';
import { routeParams, translate } from '../../../../../shared/shared.global-service';
import { contentGlobalSuccess } from '../../../../content.error';
import { TableColumn } from 'packages/client/src/app/modules/shared/components/kit/table/table.types';
import { CategoryGridItemObject } from '@it2go/types';
import { TableComponent } from 'packages/client/src/app/modules/shared/components/kit/table/table.component';
import { ConfirmBuilder } from 'packages/client/src/app/modules/shared/service/confirm.builder';
import {
    ServiceSettingsDocumentsCategoryDialogComponent,
} from './service-settings-documents-category-dialog/service-settings-documents-category-dialog.component';
import { activeColumn } from 'packages/client/src/app/modules/shared/components/kit/table/table.fields';
import { BaseDialogService } from '../../../../../../components/kit/base-dialog/base-dialog-service';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { CardTableComponent } from '../../../../../shared/components/kit/table/card-table.component';

@Component({
    selector: 'app-service-settings-documents',
    templateUrl: './service-settings-documents.component.html',
    providers: [ServiceSettingsDocumentsStore],
    imports: [
        CardTableComponent,
    ],
})
export class ServiceSettingsDocumentsComponent {
    protected readonly store = inject(ServiceSettingsDocumentsStore);
    public readonly dialogService = inject(BaseDialogService);
    protected readonly confirm = inject(ConfirmBuilder);

    protected readonly categoryTable = viewChild<TableComponent>('documentCategoryTable');

    protected readonly prefix = 'service.settings.documents.';
    protected readonly prefixCategory = 'service.settings.documents.category.';

    protected readonly columnsCategory: TableColumn[] = [
        activeColumn,
        {
            name: 'name',
        },
    ];

    protected readonly additionalFilterCategory = computed(() => {
        return FilterBuilder.filter({
            serviceId: routeParams.serviceId(),
            organizationId: this.store.globalGlobalStore.organizationStore.selectedId(),
            isEditable: true,
        }).filter;
    });

    protected openCategoryDialog(item: CategoryGridItemObject | null = null) {
        const ref = this.dialogService.open(
            ServiceSettingsDocumentsCategoryDialogComponent,
            {
                header: translate.instant('service.settings.documents.category.label'),
                styleClass: 'p-dialog-width-30',
                data: {
                    serviceId: routeParams.serviceId(),
                    category: item,
                },
            });

        ref?.onClose.subscribe((res) => {
            if (res && res.refresh) {
                this.categoryTable()?.reload();
            }
        });
    }

    protected async deleteCategory(event: any) {
        this.confirm.confirmDelete(
            async () => {
                this.store.api.deleteFileCategory({ id: event.item.id }).then((res) => {
                    contentGlobalSuccess.next('common.deleted');
                    this.categoryTable()?.reload();
                }).catch(() => {
                    contentGlobalSuccess.next('common.error');
                });
            },
            event,
        );
    }

    protected readonly categoryFrag = categoryFrag;
}
